import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './EmailsField.module.scss';

const EmailsField: React.FC = () => {
	const { report } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="emailMainRecipientLabel" theme="neutralLight" size="xs" />
			<div className={style.emailsList}>
				{report?.emails.length
					? report.emails.map((el, i) => {
							return (
								<div key={el + String(i)} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default EmailsField;
